import { SESSION_CREATE, SESSION_DESTROY } from '../constants/sessionTypes';

export function sessionCreate(email, password) {
  return {
    type: SESSION_CREATE,
    payload: { email: email, password: password }
  };
}

export function sessionDestroy() {
  return { type: SESSION_DESTROY };
}



// WEBPACK FOOTER //
// ./app/actions/sessionActions.js